import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CommonService } from "app/reusable/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-delete-case-type",
  templateUrl: "./delete-case-type.component.html",
  styleUrls: ["./delete-case-type.component.scss"],
})
export class DeleteCaseTypeComponent implements OnInit, OnDestroy {
  dialogOpened = false;
  @Input() casetype;
  @Output() Change: EventEmitter<{
    CaseType;
    dialogstatus;
  }> = new EventEmitter();
  private _subject$: Subject<boolean> = new Subject();

  constructor(private CommonService: CommonService) { }

  ngOnInit() { }

  public Delete() {
    let deleteUrl: string = `CaseType/Delete/${this.casetype.ctyId}`;

    this.CommonService.delete(deleteUrl).pipe(takeUntil(this._subject$)).subscribe((res) => {
    });

    this.Change.emit({
      CaseType: this.casetype,
      dialogstatus: this.dialogOpened,
    });
  }

  public Cancel() {
    this.Change.emit({ CaseType: "", dialogstatus: this.dialogOpened });
  }

  public close(status) {
    this.dialogOpened = false;
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}